import Hero from "../../../../src/contents/home/hero.mdx";
import Integrations from "../../../../src/contents/home/integrations.mdx";
import Features from "../../../../src/contents/home/features.mdx";
import Graphs from "../../../../src/contents/home/graphTypes.mdx";
import Benefits from "../../../../src/contents/home/benefits.mdx";
import SEO from "../../../../src/components/seo";
import React from 'react';
export default {
  Hero,
  Integrations,
  Features,
  Graphs,
  Benefits,
  SEO,
  React
};